import Hud from 'app/ui/Hud';
import ButtonSimple from 'app/ui/buttons/ButtonSimple';
import { SCREEN_WELCOME_WAIT_TIME_MIN, SCREEN_WELCOME_WAIT_TIME_MAX } from 'app/constants/AppConstants';

import * as AppTrackingEvents from 'app/constants/AppTrackingEvents';

class Welcome extends Phaser.State {
  init(game) {}

  preload(game) {}

  create(game) {
    this.game = game;

    this.background = this.game.make.image(0, 0, 'bg_welcome');
    this.background.anchor.set(0.5, 0.5);
    this.game.add.existing(this.background);

    this.container = this.game.add.group();
    this.logo = this.game.make.image(0, 0, 'logo_game');
    this.logo.anchor.set(0.5);
    this.logo.position.set(this.game.defaultWidth * 0.5, 87);

    if (settings.tune_in_image != '') {
      this.tunein = this.game.make.image(0, 0, 'ui', settings.tune_in_image);
      this.tunein.anchor.set(1);
      this.tunein.position.set(this.game.defaultWidth - (this.game.defaultWidth - this.game.width) / 2 - 40, this.game.defaultHeight - 70);
    }

    this.createCharacters();

    this.bgFront = this.game.make.image(0, this.background.height / 2, 'bg_welcome_front');
    this.bgFront.anchor.set(0.5, 1);
    this.background.addChild(this.bgFront);

    this.btnPlay = new ButtonSimple({ game: this.game, id: 'btn_play', skin: 'btn_play' });
    this.btnPlay.anchor.set(0.5);
    this.btnPlay.x = this.game.defaultWidth * 0.5;
    this.btnPlay.y = this.game.defaultHeight * 0.75;
    this.btnPlay.onInputDown.add(this.handlePlayGame, this);
    this.container.add(this.btnPlay);

    this.game.windowEventController.handleWindowResize();
    this.game.scale.onSizeChange.add(this.positionContainer, this);
    this.positionContainer();

    this.game.add.existing(this.container);
    this.game.hud.activate({ id: Hud.WELCOME });
    this.game.hud.fadeIn();

    this.container.add(this.logo);
    if (this.tunein) {
      this.container.add(this.tunein);
    }

    this.game.sounds.playBackgroundMusic();

    this.state = Welcome.STATE_SPAWN;
    this.waitTime = 0;
    this.timer = 0;

    this.paused = false;

    this.game.controller.gameModel.warningComplete = false;
    this.game.controller.gameModel.tutorialComplete = false;

    if (!Phaser.Device.desktop) {
      //this.bindedHandleFullscreenRequest = this.handleRequestFullscreen.bind(this);
      //this.game.canvas.addEventListener('click', this.bindedHandleFullscreenRequest);
    }
  }

  handleRequestFullscreen() {
    this.game.scale.startFullScreen(false);
    this.game.aspectController.updateGameSize();
    this.game.canvas.removeEventListener('click', this.bindedHandleFullscreenRequest);
  }

  createCharacters() {
    this.apple = this.game.make.spine(0, 0, 'appleWalks');
    this.apple.anchor.set(0.5, 1);
    this.apple.setAnimationByName(0, 'run_side', true);
    this.apple.position.set(-this.background.width / 2 - 500, 575 - this.background.height / 2);
    this.background.addChild(this.apple);

    this.onion = this.game.add.spine(0, 0, 'onionWalks');
    this.onion.anchor.set(0.5, 1);
    this.onion.setAnimationByName(0, 'run_side', true);
    this.onion.position.set(-this.background.width / 2 - 500, 565 - this.background.height / 2);
    this.background.addChild(this.onion);

    // PhaserSpine.SpinePlugin.DEBUG = true;
  }

  positionContainer() {
    const x = (this.game.width - this.game.defaultWidth) * 0.5;
    const y = 0;
    const sx = this.game.width / this.game.defaultWidth;
    const sy = this.game.height / this.game.defaultHeight;
    const scale = Math.max(sx, sy);
    this.background.scale.set(scale);
    this.background.position.set(this.game.width / 2, this.game.height / 2);

    if (this.tunein) {
      this.tunein.position.set(this.game.defaultWidth - (this.game.defaultWidth - this.game.width) / 2 - 40, this.game.defaultHeight - 70);
    }

    // let scale = this.game.width * 0.5 / this.container.width;
    // this.logo.scale.set(Math.min(0.5, scale));

    this.container.position.set(x, y);
  }

  cartoonSiteLink() {
    window.open(this.game.copy.getCopy('cn_site_link'), '_blank');
  }

  update() {
    this.apple.update();
    this.onion.update();
    if (!this.game.controller.gamePaused) {
      if (this.state === Welcome.STATE_SPAWN) {
        this.spawnRandomCharacter();
      }
    }
  }

  spawnRandomCharacter() {
    let rand = this.game.rnd.integerInRange(0, 1);
    let character = this.apple;
    switch (rand) {
      case 0:
        character = this.apple;
        break;
      case 1:
        character = this.onion;
        break;
    }
    //spawn apple for now

    let randDir = this.game.rnd.integerInRange(0, 1);
    let dir = -1;
    switch (randDir) {
      case 0:
        dir = -1;
        break;
      case 1:
        dir = 1;
        break;
    }

    let tween;
    if (dir === -1) {
      character.x = this.background.width / 2 + 500;
      tween = this.game.add.tween(character).to({ x: -this.background.width / 2 - 500 }, 4000, Phaser.Easing.Linear.None, true);
      character.scale.x = 1;
    }

    if (dir === 1) {
      character.x = -this.background.width / 2 - 500;
      tween = this.game.add.tween(character).to({ x: this.background.width + 500 }, 4000, Phaser.Easing.Linear.None, true);
      character.scale.x = -1;
    }

    tween.onComplete.add(this.randomWaitTime, this);

    this.state = Welcome.STATE_RUN;
  }

  randomWaitTime() {
    let randomTime = this.game.rnd.integerInRange(SCREEN_WELCOME_WAIT_TIME_MIN, SCREEN_WELCOME_WAIT_TIME_MAX);
    this.game.time.events.add(
      randomTime,
      () => {
        this.state = Welcome.STATE_SPAWN;
      },
      this
    ).autoDestroy = true;
  }

  handlePlayGame() {
    this.game.controller.startCharacterSelect();
  }

  shutdown(game) {
    // remove listeners
    game.scale.onSizeChange.remove(this.positionContainer, this);
    this.btnPlay.onInputDown.remove(this.handlePlayGame, this);

    // destroy
    this.background.destroy(true);
    this.container.destroy(true);
    this.logo.destroy(true);
    this.apple.destroy(true);
    this.onion.destroy(true);
    this.btnPlay.destroy(true);

    // clear up
    this.background = null;
    this.container = null;
    this.logo = null;
    this.apple = null;
    this.onion = null;
    this.cat = null;
    this.btnPlay = null;
  }
}

Welcome.STATE_SPAWN = 'Welcome.STATE_SPAWN';
Welcome.STATE_RUN = 'Welcome.STATE_RUN';
Welcome.STATE_WAIT = 'Welcome.STATE_WAIT';

export default Welcome;
